export default __webpack_public_path__ + "static/media/aqi-very-poor.55cbd61f.svg";